module.exports = __webpack_public_path__ + "static/mascot_welcome_logo-1a00eac1268182e9d65578bc5e72a04b.png";